import Swiper, { Navigation, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [EffectFade, Navigation],
		autoHeight: true,
		slidesPerView: 1,
		spaceBetween: 32,
		centerInsufficientSlides: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

export default () => {
	const testimonialsSliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.testimonials .slider")
	);

	if (!testimonialsSliders) return;

	testimonialsSliders.map((element: HTMLElement) => Slider(element));
};
